import { render, staticRenderFns } from "./ScheduledCalls.container.vue?vue&type=template&id=23062002&scoped=true&"
import script from "./ScheduledCalls.container.vue?vue&type=script&lang=js&"
export * from "./ScheduledCalls.container.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledCalls.container.vue?vue&type=style&index=0&id=23062002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23062002",
  null
  
)

export default component.exports